import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { SubmitIcon } from 'assets/svg';
import { useAppDispatch } from 'features/app/hooks';
import { ReportType } from 'features/call/vrs-call-comments/enums';
import { setReportType } from 'features/call/vrs-call-comments/store';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import { Button } from 'features/ui/elements';

interface VrsCallCommentsFormButtonsProps {
  isValid: boolean;
}

export const VrsCallCommentsFormButtons: FC<
  VrsCallCommentsFormButtonsProps
> = ({ isValid }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'callCommentsNonBillable',
  });
  const { t: ct } = useTranslation();

  const dispatch = useAppDispatch();

  return (
    <>
      <ReadyForMoreCallsBtn
        disabled={!isValid}
        type='submit'
        fullWidth
        size='large'
        color='primary'
        title={t('submitReport')}
      >
        <StyledDescription>
          <StyledSubmitIcon />
          {t('submitReport')}
        </StyledDescription>
      </ReadyForMoreCallsBtn>
      <TakeBreakBtn
        fullWidth
        size='small'
        color='secondary'
        title={ct('cancel')}
        onClick={() => dispatch(setReportType(ReportType.DEFAULT))}
      >
        {ct('cancel')}
      </TakeBreakBtn>
    </>
  );
};

const ReadyForMoreCallsBtn = styled(Button)`
  margin-top: ${theme.spacing(16)};
`;

const TakeBreakBtn = styled(Button)`
  margin-top: ${theme.spacing(8)};
`;

const StyledSubmitIcon = styled(SubmitIcon)`
  margin-right: ${theme.spacing(6)};
`;

const StyledDescription = styled('div')`
  display: flex;
  align-items: center;
`;
